import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AdminService } from '../../service/admin.service';
import { UtilService } from '../../service/util.service';
import * as constants from '../../app.constants';
import { NotificationsService } from 'angular2-notifications';
import { PagerService } from '../../pipe/pagination';
import { IMyDpOptions } from 'mydatepicker';
import { DashboardData } from '../../model/dashboard-data';
declare let $: any;

@Component({
  selector: 'dashboard1',
  template: require('./dashboard1.component.html'),
  styles: [require('./dashboard1.component.css')]
})

export class Dashboard1Component implements OnInit, AfterViewInit {

  public model: DashboardData;
  public errorMsg: string;
  // public quarters: string[] = ['JAN-MAR', 'APR-JUN', 'JUL-SEP', 'OCT-DEC'];
  public quarters: string[] = [
    'January - March',
    'April - June',
    'July - September',
    'October - December'
  ];

  public title = '';
  public chartOptions = {
    responsive: true,
  };
  public colors = [
    {
      backgroundColor: [
        "#36be9a",
        "#c1c1c0",
        "#e24e58",
        "#e37e00",
        "#8d41b3"
      ]
    }
  ];
  public labels =  [];
  public chartData = [];
  public chartDataReceived: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public _notificationsService: NotificationsService,
    private adminService: AdminService,
    private pagerService: PagerService) {
  }

  public ngOnInit(): void {
    this.model = new DashboardData();
    this.getDashboardData();
  }

  public ngAfterViewInit(): void {
  }

  protected getDashboardData(): void {
    console.debug('Get Dashboard Data');
    this.adminService
      .getCall(constants.URLs.dashboardData, true)
      .then((res) => {
          console.log('getDashboardData res');
          console.log(res);
          this.model = res;

          this.labels =  [
            'Active Tickets ( ' + this.model.active_tickets + ' )',
            'Inactive Tickets ( ' + this.model.inactive_tickets + ' )',
            'Fake Tickets ( ' + this.model.fake_tickets + ' )',
            'Fake Ticket Requests ( ' + this.model.flagged_requests + ' )',
            'Admin Tickets ( ' + this.model.admin_tickets + ' )'
          ];
          this.chartData = [
            {
              label: '',
              data: [
                this.model.active_tickets,
                this.model.inactive_tickets,
                this.model.fake_tickets,
                this.model.flagged_requests,
                this.model.admin_tickets,
              ],
              barPercentage: 0.5,
              barThickness: 50,
              maxBarThickness: 80,
              minBarLength: 3,
              backgroundColor: 'rgba(25,10,24,0.2)',
            }
          ];
          this.chartDataReceived = true;

      })
      .catch((error: any) => {
          try {
            this.errorMsg = error.json().error_msg || constants.messages.serverError;
            console.debug('Dashboard1Component- an error occurred', error);
          } catch (e) {
            this.errorMsg = error.message ? error.message : constants.messages.serverError;
            console.error('Dashboard1Component- an error occurred', error);
            this.adminService.showErrorToast(this.errorMsg);
          }
      });
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/manage/dashboard1/dashboard1.component.ts